export const accentColors = [
  '#1867C0',
  '#5CBBF6',
  '#742ED5',
  '#2E50A8',
  '#C75CD9',
];